import { DataGrid } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import { Stack, Button, Container, Typography, Box, Card, TextField } from '@mui/material';
import { getApi } from 'views/services/api';
import moment from 'moment';

// Component definition
const KotReports = () => {
  const [originalKotData, setOriginalKotData] = useState([]);
  const [kotData, setKotData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const hotel = JSON.parse(localStorage.getItem('hotelData'));

  // Fetch data from API
  const fetchKOTData = async () => {
    try {
      const response = await getApi(`api/kitchenorderticket/viewallKot/${hotel?.hotelId}`);
      if (response.status === 204) {
        setKotData([]);
        setOriginalKotData([]);
      } else {
        setKotData(response?.data?.mergedData);
        setOriginalKotData(response?.data?.mergedData);
      }
    } catch (error) {
      console.log('Error fetching data:', error);
    }
  };

  // Handle filter logic
  const handleFilter = () => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (isNaN(start) || isNaN(end)) {
      alert('Please select valid start and end dates.');
      return;
    }

    end.setHours(23, 59, 59, 999);

    const filteredData = originalKotData.filter((item) => {
      const createdDate = new Date(item.createdDate);
      return createdDate >= start && createdDate <= end;
    });

    setKotData(filteredData);
  };

  // Effect to fetch data on mount
  useEffect(() => {
    fetchKOTData();
  }, []);

  // Define columns for DataGrid
  const columns = [
    { field: 'staffName', headerName: 'Name', flex: 1, cellClassName: 'name-column--cell--capitalize' },
    { field: 'description', headerName: 'Description', flex: 1 },
    {
      field: 'createdDate',
      headerName: 'Date',
      flex: 1,
      renderCell: (params) => <Box>{moment(params.value).format('YYYY-MM-DD')}</Box>
    }
  ];

  return (
    <Container>
      <Stack direction="row" alignItems="center" mb={5} justifyContent="space-between">
        <Typography variant="h4">KOT Report</Typography>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
          <TextField
            label="Start Date"
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="End Date"
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
          />
          <Button variant="contained" onClick={handleFilter}>
            Filter
          </Button>
        </Stack>
      </Stack>
      <Box width="100%">
        <Card style={{ height: '600px', paddingTop: '15px' }}>
          <Typography variant="h4" sx={{ margin: '2px 15px' }}>
            Ticket ( {kotData?.length || 0} )
          </Typography>
          {kotData && <DataGrid rows={kotData} columns={columns} getRowId={(row) => row?._id} />}
        </Card>
      </Box>
    </Container>
  );
};

export default KotReports;
